import { IResourceStreamController } from 'library/ts/player/adapter/interfaces/resource/config/playback/IResourceStreamController';

/**
* @description These are HLSjs configurations and buffer settings.
* Please don't change their values. They were carefully selected after weeks of experiments. This is for prolongedplayback of HLS livestreams.
* Critical for Comcast and Xbox, might be applied to other platforms based on need.
*/
export const streamController: IResourceStreamController = {
	maxBufferLength: 10,
	maxMaxBufferLength: 10,
	maxBufferSize: 5 * 1000 * 1000,
	liveBackBufferLength: 12,
	liveSyncDurationCount: 6,
	stretchShortVideoTrack: true,
	maxBufferHole: 2.5,
	maxStarvationDelay: 10,
	highBufferWatchdogPeriod: 5,
	maxFragLookUpTolerance: 2.5,
	nudgeOffset: 0.25,
	nudgeMaxRetry: 5
};